<template>
    <div v-if="canVerifOcr" class="ocr-item-list-action">
        <CompassButton
            :label="$t.__('common.actions.verify')"
            type="tertiary"
            :disabled="disableVerify"
            @click="goToVerif"
        />
        <CompassButton
            :label="$t.__('common.actions.delete')"
            type="tertiary-destructive"
            @click="deleteFile"
        />
    </div>
</template>

<script>
import { goToUrl } from '../../helpers';
import Ocr from 'api/ocr';

export default {
    props: {
        id: {
            type: [String, Number],
            required: true,
        },
        canVerifOcr: {
            type: Boolean,
            required: true,
        },
        listinghash: {
            type: String,
            required: true,
        },
    },
    computed: {
        disableVerify() {
            return ['processing', 'pending'].includes(
                this.$store.state[this.listinghash].rows.find((row) => row.id === this.id)?.state,
            );
        },
    },
    methods: {
        goToUrl,
        goToVerif() {
            this.goToUrl(`/purchase/incoming/verification/${this.id}`);
        },
        deleteFile() {
            Ocr.deleteOcr(this.id).then(() => {
                EventBus.emit('listing:refresh');
            });
        },
    },
};
</script>

<style scoped>
.ocr-item-list-action {
    display: flex;
    gap: var(--spacing-1);
    justify-content: center;
}
</style>
